export default "__VITE_ASSET__1cdc2afd__"